var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIcFiledownloadOn = function SvgIcFiledownloadOn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 3.9 17.2.8C16.6.3 15.8 0 15 0H4.3c-1 0-1.8.8-1.8 1.8v20.3c0 1 .8 1.8 1.8 1.8h15.4c1 0 1.8-.8 1.8-1.8V6.3c.1-.9-.3-1.7-1-2.4zM7.7 9.3c.4-.4 1-.4 1.4 0l1.9 1.9V5.8c0-.5.4-.9 1-.9s1 .4 1 .9v5.4l1.9-1.9c.4-.4 1-.4 1.4 0 .4.4.4 1 0 1.4l-3.6 3.6c-.2.2-.4.3-.7.3s-.5-.1-.7-.3l-3.6-3.6c-.4-.4-.4-1 0-1.4zm9.4 8.9H6.9c-.5 0-1-.4-1-1 0-.5.4-1 1-1h10.2c.5 0 1 .4 1 1 0 .5-.4 1-1 1z"
  })));
};
export default SvgIcFiledownloadOn;